export const NotificationTypes = {
  CARD_EXPIRATION: 'CARD_EXPIRATION',
  TICKET_EXPIRATION: 'TICKET_EXPIRATION',
};

export const NotificationTypeI18nKeys = {
  [NotificationTypes.CARD_EXPIRATION]: 'notificationSetting.cardExpirationMessage',
  [NotificationTypes.TICKET_EXPIRATION]: 'notificationSetting.ticketExpirationMessage',
};
